import { Component, OnInit, AfterViewInit, ViewChild } from "@angular/core";
import { AuthService } from "../auth.service";
import { AppCommonService } from "../appcommon.service";
import { ActivatedRoute, Router } from '@angular/router';
import { IAccount } from "../headerandnavigation/accounts/account";
import { InvoicingService } from "./invoicing.service";
import { DataTableDirective } from "angular-datatables";
import { Subject } from "rxjs/Subject";
import { Invoice, InvoiceDocumentModel, InvoicesModel } from "./invoicing";
import { Http, ResponseContentType, RequestOptions, RequestMethod } from "@angular/http";
import { ApiEndPoints } from "../api.endpoints";
import { HeaderAndNavigationService } from "../headerandnavigation/headerandnavigation.service";
import { LoaderService } from "../LoaderService";
declare var $: any;

@Component({
  templateUrl: "./invoicingdetail.invoices.component.html"
})
export class HistoricalInvoicingComponent implements OnInit, AfterViewInit {
  @ViewChild(DataTableDirective)
  dtElement: DataTableDirective;
  dtOptions: any = {};
  dtTrigger: Subject<any> = new Subject();
  public pageTitle: string = 'Historical Invoices';
  public invoiceName: string = 'historicalinvoices';
  public activeAccountId: string = '';
  public accessAccounts: IAccount[];
  public processAccount: IAccount;
  public invoicesList: Invoice[];
  constructor(
    private http: Http,
    private authService: AuthService,
    private appCommonService: AppCommonService,
    public invoicingService: InvoicingService,
    private route: ActivatedRoute,
    private router: Router,
    public headerAndNavigationService: HeaderAndNavigationService,
    public loaderService: LoaderService
  ) {
    this.appCommonService.pageContentAdditionalClass = "";
    this.appCommonService.pageName = this.pageTitle;
  }
  ngOnInit(): void {
    this.headerAndNavigationService.showhideNav(false, true);
    this.accessAccounts = this.authService.getSelectedAccessAccounts();
    this.processAccount = null;
    this.processAccount = this.accessAccounts[0];
    this.invoicesOnInit();
    this.datefilerInitiate();
    if (!$.fn.DataTable.isDataTable('#statementdatatable')) {
      $('#statementdatatable').DataTable({
        //dom: "fltB<'row DTTTFooter'<'col-sm-6'i><'col-sm-6'p>>",
        dom: '<"top"i<"clear">>rt<"bottom"i<"clear">>',
        responsive: true,
        info: false,
        iDisplayLength: 10,
        ordering: false,
      });
    }
  }

  datefilerInitiate() {
    $(document).ready(function () {
      jQuery.extend($.fn.dataTableExt.oSort, {
        "date-uk-pre": function (a) {
          if (a == null || a == "") {
            return 0;
          }
          var ukDatea = a.split('-');
          return (ukDatea[2] + ukDatea[1] + ukDatea[0]) * 1;
        },

        "date-uk-asc": function (a, b) {
          return ((a < b) ? -1 : ((a > b) ? 1 : 0));
        },

        "date-uk-desc": function (a, b) {
          return ((a < b) ? 1 : ((a > b) ? -1 : 0));
        }
      });
    });
  }

  afterloaddata() {
    const self = this;
    $('#invoicesdatatable').DataTable({
      dom: '<"top"fipB<"clear">>rt<"bottom"ipB<"clear">>',
      responsive: true,
      info: false,
      iDisplayLength: 15,
      order: [],
      columnDefs: [{ width: 32, targets: 0, visible: false }, { orderable: false, targets: [0, 4] }, { bSearchable: false, targets: [0, 4] }, { type: 'date-uk', targets: [3] }],
      fixedColumns: true,
      //buttons: [
      //  {
      //    extend: 'collection',
      //    text: 'Download <i class="fa fa-angle-down"></i>',
      //    buttons: [
      //      'excelHtml5',
      //      //'csvHtml5',
      //      'pdfHtml5']
      //  }
      //]
      buttons: [
        {
          extend: 'collection',
          text: 'Download <i class="fa fa-angle-down"></i>',
          buttons: [{
            extend: 'excelHtml5',
            title: 'invoices',
            exportOptions: {
              columns: [0, 1, 2, 3],
              orthogonal: 'sort'
            },
            customizeData: function (data) {
              for (var i = 0; i < data.body.length; i++) {
                for (var j = 0; j < data.body[i].length; j++) {
                  data.body[i][j] = '\u200C' + data.body[i][j];
                }
              }
            }
          },
          {
            extend: 'pdfHtml5',
            title: 'invoices',
            exportOptions: {
              columns: [0, 1, 2, 3]
            }
          }
          ]
        }
      ]
    });

    var table = $('#invoicesdatatable').DataTable();

    $('.dataTables_filter input', table.table().container())
      .off('.DT')
      .on('keyup.DT cut.DT paste.DT input.DT search.DT', function (e) {
        if (this.value.length >= 1) {
          // Call the API search function
          table.search(this.value.replace(/\u200C/g, '')).draw();
        }

        // Ensure we clear the search if they backspace far enough
        if (this.value === "") {
          table.search("").draw();
        }
      });

  }

  invoicesOnInit(): void {
    this.loadInvoicesList();
  }

  loadInvoicesList() {
    this.loaderService.display(true);
    var model: InvoicesModel = new InvoicesModel();
    model.AccountId = [];
    model.Token = this.authService.getToken().access_token;
    //model.EndPointURL = ApiEndPoints.HistoricalInvoicesEndPoint;
    this.accessAccounts.forEach(item => {
      model.AccountId.push(item.id);
    });
    this.invoicingService.getHistoricalInvoices(model)
      .subscribe(
        (invoices: Invoice[]) => {
          //debugger
          this.invoicesList = invoices;
          //debugger
          setTimeout(() => {
            this.afterloaddata();
            this.loaderService.display(false);
          }, 100);
          //this.dtTrigger.next();
          //this.loaderService.display(false);
        },
        (error: any) => {
          this.loaderService.display(false);
          this.invoicingService.showError("Invoices retrieval problem", <any>error)
        }
      );

    var table = $('#invoicesdatatable').DataTable();

    $('.dataTables_filter input', table.table().container())
      .off('.DT')
      .on('keyup.DT cut.DT paste.DT input.DT search.DT', function (e) {
        alert("A");
        if (this.value.length >= 1) {
          // Call the API search function
          table.search(this.value.replace(/\u200C/g, '')).draw();
        }

        // Ensure we clear the search if they backspace far enough
        if (this.value === "") {
          table.search("").draw();
        }
      });
  }

  DownloadInvoiceDocument(inv: Invoice) {
    this.loaderService.display(true);
    var model: InvoiceDocumentModel = new InvoiceDocumentModel();
    var selectedAcc = this.accessAccounts.filter(x => x.name == inv.accountNumber)[0];    
    if (selectedAcc != undefined && selectedAcc != null) {
      model.InvoiceId = inv.id;
      model.AccountId = selectedAcc.id;
      model.Token = this.authService.getToken().access_token;
     //model.EndPointURL = ApiEndPoints.HistoricalInvoiceDocumentByIdEndPoint// ApiEndPoints.InvoiceDocumentByIdEndPoint; 
      this.invoicingService.getHistoricalInvoiceDocument(model);
    }
    else {
      this.loaderService.display(false);
      alert("No Data found for this record");
    }
  }

  ngAfterViewInit(): void {

  }
}



// WEBPACK FOOTER //
// ./src/app/invoicing/invoicingdetail.historicalinvoice.component.ts